import { render, staticRenderFns } from "./TradeTransfer.vue?vue&type=template&id=2c791123&scoped=true&"
import script from "./TradeTransfer.vue?vue&type=script&lang=js&"
export * from "./TradeTransfer.vue?vue&type=script&lang=js&"
import style0 from "./TradeTransfer.vue?vue&type=style&index=0&id=2c791123&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c791123",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c791123')) {
      api.createRecord('2c791123', component.options)
    } else {
      api.reload('2c791123', component.options)
    }
    module.hot.accept("./TradeTransfer.vue?vue&type=template&id=2c791123&scoped=true&", function () {
      api.rerender('2c791123', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Complements/TradeTransfer.vue"
export default component.exports